"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isPortrait = function (aspectRatio) {
    if (aspectRatio === void 0) { aspectRatio = '4:3'; }
    var _a = aspectRatio.split(':'), width = _a[0], height = _a[1];
    return parseInt(width) < parseInt(height);
};
exports.default = isPortrait;
